import { defineStore } from 'pinia';
import type { RouteLocationNormalizedLoadedGeneric } from 'vue-router';

export const useStoreQuery = defineStore('clientQuery', {
  state: () => ({
    isChangePrograming: false,
    route: null as RouteLocationNormalizedLoadedGeneric | null,
  }),
  actions: {
    /**
     * Action that set new query parameter
     *
     * @param query - query parameter and it's value
     */
    async setParam(query: Record<string, string>) {
      if (import.meta.browser) {
        const router = useRouter();
        const route = this.route || useRoute();

        this.setFlagChangePrograming(true);

        await router.push({
          params: {
            ignoreScroll: '1',
          },
          query,
          hash: route.hash,
        });
      }
    },

    /**
     * Action that set existing query parameter's value
     *
     * @param params - query parameter and it's value
     */
    async updateParam(query: Record<string, string>) {
      if (import.meta.browser) {
        this.setFlagChangePrograming(true);

        const router = useRouter();
        const route = this.route || useRoute();
        const newQuery = { ...route.query, ...query };

        await router
          ?.push({
            params: {
              ignoreScroll: '1',
            },
            query: newQuery,
            hash: route.hash,
          })
          ?.catch(() => {});
      }
    },

    /**
     * Action that remove query parameter
     *
     * @param params - query parameter and it's value
     */
    async removeParam(param: string) {
      if (import.meta.browser) {
        this.setFlagChangePrograming(true);

        const router = useRouter();
        const route = this.route || useRoute();
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { [param]: _dummy, ...query } = route.query;

        await router
          ?.push({
            params: {
              ignoreScroll: '1',
            },
            query,
            hash: route.hash,
          })
          ?.catch(() => {});
      }
    },

    async removeParams(params: Record<string, any>) {
      if (import.meta.browser) {
        this.setFlagChangePrograming(true);

        const router = useRouter();
        const route = this.route || useRoute();

        await router
          ?.replace({
            params: {
              ignoreScroll: '1',
            },
            query: Object.entries(route.query).reduce((acc, { 0: key, 1: value }) => {
              if (params[key] || params[key] === '') {
                return acc;
              }
              return { ...acc, [key]: value };
            }, {}),
            hash: route.hash,
          })
          ?.catch(() => {});
      }
    },

    /**
     * Action that removes all query parameters
     */
    async resetParams() {
      if (import.meta.browser) {
        this.setFlagChangePrograming(true);

        const router = useRouter();
        const route = this.route || useRoute();

        await router
          ?.replace({
            params: {
              ignoreScroll: '1',
            },
            query: {},
            hash: route.hash,
          })
          ?.catch(() => {});
      }
    },
    setFlagChangePrograming(value: boolean) {
      this.isChangePrograming = value;
    },
    updateRoute(route: RouteLocationNormalizedLoadedGeneric) {
      this.route = route;
    },
  },
});
